// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
require('../scss/utils/bootstrap/bootstrap.min.css');

var $ = require('jquery');
window.jQuery = $
require('bootstrap-sass/assets/javascripts/bootstrap.min.js');
//语言切换
var lang = '';
var irHref = '/ir';
var commonApi = require('../commonApi'); 
var apiLast = commonApi.api.pcApi;
function initChangePage() {
	// 获取中英文
	var langInput = document.getElementById('lang');
	lang = getCookie('lang') || (langInput ? langInput.value : undefined);
//	console.log('test');
	//中文时 正文为微软雅黑(默认) 英文时 正文为Helvetica
	// if (lang == 'en'){
	//     $('body').css('font-family','Helvetica');
	// }else{
	//     $('body').css('font-family','MicrosoftYahei');
	// }
	//跳转
	$('.falseA').click(function() {
		if(lang === 'tr') {
			changeLocale('zh');
		}
		var href = $(this).attr('href');
		if(href == 'news') {
			href = '/' + href;
			window.location.href = href + '?displayType=img&nav=mediaNav';
		} else if(href == 'join') {
			window.open('https://app.mokahr.com/apply/huaxing');
		} else {
			href = '/' + href;
			window.location.href = href;
		}
	})
	

	//回到顶部 按钮
	var WH = $(window).height();
	$(window).scroll(function() {
		//      console.log(1);
		if(WH < $(document).scrollTop()) {
			$('.returnTop-box').show();
		} else {
			$('.returnTop-box').hide();
		}
	});

	  $('.returnTop-box').click(function(){
//	  	console.log("返回顶部")
	      $('body,html').stop().animate({
	          scrollTop: 0
	      }, 1000);
	      return false;
	  })


	//语言切换
	$('.lang-btn').click(function() {
		lang = getCookie('lang');

		if(lang == 'en') {
			lang = 'zh';
			// $('.zh').hide();
		} else {
			lang = 'en';
		}

		changeLocale(lang);
		window.location = '/';

	})

		//IR 语言切换 （包括简体、繁体、英文）
		$('.lang-btn-ir').click(function() {
			lang = $(this).attr('data-lang');
			irHref = $(this).attr('data-href') || '/ir';
			// if(lang == 'en') {
			// 	lang = 'zh';
			// 	// $('.zh').hide();
			// } else {
			// 	lang = 'en';
			// }
	
			changeLocale(lang);
			window.location = irHref;
	
		})
	

	function changeLocale(locale) {
		var Cookies = require('js-cookie');
		Cookies.set('lang', locale);
	}
	// console.log('1');
	if(lang == 'en') {
		$('.zh').hide();
		$('.zh-tag').hide();
		$('.en').show();
		$('.en-tag').show();
	} else {
		$('.zh').show();
		$('.zh-tag').show();
		$('.en').hide();
		$('.en-tag').hide();

	}

	//footer wx display code
	$('.WX-logo').popover({
		html: true
	});
	$('.WX-logo').hover(function() {

		$(this).popover('show');

	}, function() {

		$(this).popover('hide')
	});

	//display model
	$('.showModal').click(function() {
		var targetClass = $(this).attr('targetClass');
		var targetClassObj = $('.' + targetClass + '');
		targetClassObj.modal('show');
	});

	//图片灰色处理
	$('.hoverImg').hover(function() {

		$(this).removeClass('gray');

	}, function() {
		$(this).addClass('gray');
	})

	return lang;

}

//获取cookie
function getCookie(cname) {
	var name = cname + '=';
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i].trim();
		if(c.indexOf(name) == 0) return c.substring(name.length, c.length);
	}
	return '';
}

//获取api地址
function getAPI() {
//	var api = 'http://10.101.194.3/';
	// var api = 'http://website.huaxing.com/';
	var api = apiLast;
//	var api = 'http://10.101.96.1:9080/mockjs/7/';
	// var api = 'http://mesgz9.natappfree.cc/'; 
//	var api = 'http://10.101.96.2:8091/';
	//var api = 'http://huaxing-admin-backend.limijiaoyin.com/';
	return api;
}

function getNewsType(type) {
	var NRITNStr = '';
	if(type == 'news-reports') {
		if(lang == 'en') {
			NRITNStr = 'IN THE NEWS';
		} else {
			NRITNStr = '新闻报道';
		}
	} else if(type == 'company-news') {
		if(lang == 'en') {
			NRITNStr = 'CORPORATE NEWS';
		} else {
			NRITNStr = '公司新闻';
		}

	} else if(type == 'events') {
		if(lang == 'en') {
			NRITNStr = 'EVENTS';
		} else {
			NRITNStr = '活动新闻';
		}

	} else if(type == 'transactions') {
		if(lang == 'en') {
			NRITNStr = 'TRANSACTIONS';
		} else {
			NRITNStr = '交易新闻';
		}

	} else if(type == 'party-building-section') {
		if(lang == 'en') {
			NRITNStr = 'PARTY BUILDING';
		} else {
			NRITNStr = '党建动态';
		}

	}
	return NRITNStr;
}

function formatDate() {
	Date.prototype.Format = function(fmt) { //author: meizz
		var o = {
			'M+': this.getMonth() + 1, //月份
			'd+': this.getDate(), //日
			'h+': this.getHours(), //小时
			'm+': this.getMinutes(), //分
			's+': this.getSeconds(), //秒
			'q+': Math.floor((this.getMonth() + 3) / 3), //季度
			'S': this.getMilliseconds() //毫秒
		};
		if(/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
		for(var k in o)
			if(new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
		return fmt;
	}
}

exports.formatDate = formatDate;
exports.initChangePage = initChangePage;
exports.getCookie = getCookie;
exports.getAPI = getAPI;
exports.getNewsType = getNewsType;


// WEBPACK FOOTER //
// ./src/common.js